module.exports = __webpack_public_path__ + "img/Sudy Martin.jpg";